import React from 'react';

/**
 * Dashed horizontal rule — same SVG as PropertyDetail house-rules heading.
 * Use between major filter **categories** (not between individual options in a list).
 * @param {string} [className] Wrapper margin; default `mb-[20px]`.
 */
export function FilterDashedSeparator({ className = 'my-[20px]' }) {
  return (
    <div className={`flex items-center justify-center ${className}`.trim()} role="presentation">
      <svg width="100%" height="1px" className="block max-w-full" aria-hidden>
        <line
          x1="0"
          y1="1"
          x2="100%"
          y2="1"
          stroke="#f0f0f0"
          strokeWidth="2"
          strokeDasharray="10 4"
        />
      </svg>
    </div>
  );
}
